<template lang="pug">
.create-goods
  el-form.sku(:model="goodsData" label-width="100px" ref="fromRules")
    el-form-item(label="当前类目:" prop="categoryId")
      el-select(v-model="rootCategoryId" placeholder="选择一级类别" @change="changeFirstCategory")
        el-option(v-for="item, index in firstCategoryLs" :key="index" :label="item.name" :value="item.id")
      el-select(v-model="secendCategoryId" placeholder="选择二级类别"  @change="changeSecendCategory")
        el-option(v-for="item, index in secendCategoryLs" :key="index" :label="item.name" :value="item.id")
      el-select(v-model="categoryId" placeholder="选择三级类别" @change="changeThirdCategory")
        el-option(v-for="item, index in thirdCategoryLs" :key="index" :label="item.name" :value="item.id")

    h3 基本信息

    el-form(inline label-width="100px" :model="basicModel" :rules="basicRules")
      template(v-for="item, index in propertyList")
        span(v-if="item.type === 'DATE' && item.text === '交货期'")
          el-form-item(v-if="showDeliveryDate" :label="`${item.text}:`"  :key="index" :rules="[ { required: item.require } ]")
            el-date-picker.w-185(type="date" :editable="false" v-model="item.value"  value-format="yyyy-MM-dd" )
        el-form-item(v-else :label="`${item.text}:`"  :key="index" :rules="[ { required: item.require, message: `请输入${item.text}` }, { validator: caizhiHandler, trigger: 'blur' } ]" :prop="item.text")
          goods-texture.w-185(v-if="item.type === 'TEXT' && item.text === '材质'" :item="item" :property-list="propertyList" :ref="item.text")
          el-input.w-185(:placeholder="`请输入${item.text}`" v-model="item.value"  v-else-if="item.type === 'TEXT'")
          template(v-else-if="item.type === 'ENUM'")
            el-select.w-185(v-if="item.text === '是否预售'" v-model="item.value" :placeholder="`选择${item.text}`" @change="changeFuturesType")
              el-option(v-for="_item, _index in item.list" :key="_index" :label="_item.text" :value="_item.text")
            el-select.w-185(v-else v-model="item.value" :placeholder="`选择${item.text}`" )
              el-option(v-for="_item, _index in item.list" :key="_index" :label="_item.text" :value="_item.text")
          el-date-picker.w-185(type="date" :editable="false" v-model="item.value"  value-format="yyyy-MM-dd" v-else-if="item.type === 'DATE' && item.text !== '交货期'")

    goods-warehouse

    el-form-item(label="供应商名称:")
      el-input(v-model.trim="indefinite.itemExtInfoVO.supplierName" placeholder="请输入供应商名称" maxlength="200")

    el-form-item(label="商品副标题:")
      el-input(placeholder="副标题可以填写商品特色等内容" v-model="goodsData.subTitle" maxlength="30")

    el-form-item(label="物流配送：")
      freight-set(
        ref="freight-set"
        :freight-id="indefinite.itemExtInfoVO.transportTemplateId"
        @change="onChangeTransportTemplate"
      )

    h3 销售信息
      .tip
        span(v-if="indefinite.itemExtInfoVO.subItemType === 'NORMAL'") 资源明细只有下架后才可以删除哦~
        span.ml-20(v-if="maxPriceRange") 价格范围({{minPriceRange}} - {{maxPriceRange}})

    sale-attr(:type="indefinite.itemExtInfoVO.subItemType" v-if="indefinite.itemExtInfoVO.subItemType")

    h3 商品图片和详情说明

    el-form-item(label="上传图片:")
      el-upload(:multiple="true" :on-remove="handleRemove" :on-success="handleSuccess"  :before-upload="beforeUpload"
        :action="UPLOAD_ROOT" :file-list="imageList" :limit="5" accept="image/gif, image/jpeg, image/jpg, image/png"
        list-type="picture-card" :class="{'opacity': imageList.length >= 5}" :on-exceed="handleExceed")
        i.el-icon-plus
      .upload-tips 您可以不同的款式最多上传5张图片，图片的格式为jpg，png，不超过5M，建议您上传750*750像素的实拍大图

    el-form-item(label="详细说明:")
      editor(v-model="goodsDetail")

    el-form-item(label=" ")
      goods-release-rule(v-model="isArrageRlue")

  .operate-btn
    .flex
      el-button(@click="closePage") 取消
      el-button.ml-20(type="primary" @click="submit('CREATE')" :disabled="!isArrageRlue") 保存不上架
      el-button.ml-20(type="primary" @click="submit('VALID')" :disabled="!isArrageRlue") 上架出售
    .tips 所有商品要保存后才生效

</template>

<script>
import { UPLOAD_ROOT } from '@/common/constants/'
import editor from '@/components/editor/editor'
import saleAttr from './components/saleAttr'
import goodsWarehouse from './components/goodsWarehouse'
import freightSet from '@/components/form/freightSet'
import GoodsReleaseRule from '@/components/goodsReleaseRule'
import GoodsTexture from './components/goodsTexture'

export default {
  name: 'goodsCreate',
  data() {
    return {
      showDeliveryDate: false,
      goodsDetail: [],
      goodsData: {
        mainPicUrl: '',
        subTitle: '',
        categoryAlias: '',
        itemType: 'STEELS',
        warehouseName: ''
      } /** 商品信息 */,
      categoryId: '' /** 选中三级级类目 */,
      secendCategoryId: '' /** 选中二级类目 */,
      rootCategoryId: '' /** 选中一级类目 */,
      imageList: [] /** 上传图片列表 */,
      firstCategoryLs: [] /** 一级类目列表 */,
      secendCategoryLs: [] /** 二级类目列表 */,
      thirdCategoryLs: [] /** 三级类目列表 */,
      propertyList: [] /** 非销售属性列表 */,
      skuPVPairList: [] /** 销售属性列表 */,
      UPLOAD_ROOT,
      skuList: [
        {
          /** sku列表 */
          stockNum: 0,
          price: 0,
          amountPerUnit: 0,
          costPrice: 0,
          TPCode: '',
          status: 'VALID',
          itemSkuPVPairList: []
        }
      ],
      minPriceRange: 0,
      maxPriceRange: 0,
      priceErrors: [],
      indefinite: {
        marketPrice: '',
        stockNum: '',
        costPrice: '',
        itemExtInfoVO: {
          minOrderAmount: '',
          amountPerUnit: '',
          tpCode: '',
          transportTemplateId: 0,
          supplierName: ''
        }
      },
      isArrageRlue: true,
      basicRules: {
        材质: [
          {
            required: true,
            message: 'tecssd',
            type: 'string'
          }
        ]
      }
    }
  },
  components: {
    editor,
    saleAttr,
    goodsWarehouse,
    freightSet,
    GoodsReleaseRule,
    GoodsTexture
  },
  mounted() {
    this.getCategoryTree()
    this.$store.dispatch('clearEditor')
    this.indefinite.itemExtInfoVO.subItemType = this.$route.meta.type || 'NORMAL'
  },
  activated() {
    this.$refs['freight-set'].getList() // 重新获取运费模版
  },
  computed: {
    basicModel() {
      let map = this.propertyList.map(item => ({ value: item.value, label: item.text }))
      let final = {}
      map.forEach(item => {
        final[item.label] = item.value
      })
      return final
    }
  },
  methods: {
    /** 初始化sku信息 */
    initSkuInfo() {
      this.skuList = [
        {
          stockNum: 0,
          price: 0,
          costPrice: 0,
          TPCode: '',
          amountPerUnit: 0,
          status: 'VALID',
          itemSkuPVPairList: []
        }
      ]
      this.priceErrors = [false]
      this.propertyList = []
      this.skuPVPairList = []
    },
    /** 获取类目列表*/
    async getCategoryTree(id) {
      try {
        const result = await this.$post('items.getCategoryTree')
        if (result.success) {
          this.firstCategoryLs = result.data
          this.rootCategoryId = this.firstCategoryLs[0].id
          this.secendCategoryLs = this.firstCategoryLs[0].children
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 修改一级类目 */
    changeFirstCategory(id) {
      this.secendCategoryId = ''
      this.categoryId = ''
      this.initSkuInfo()
      this.firstCategoryLs &&
        this.firstCategoryLs.forEach(item => {
          if (item.id === id) {
            this.secendCategoryLs = item.children
          }
        })
    },
    /** 修改二级类目 */
    changeSecendCategory(id) {
      this.categoryId = ''
      this.initSkuInfo()
      let name = ''
      this.secendCategoryLs &&
        this.secendCategoryLs.forEach(item => {
          if (item.id === id) {
            this.thirdCategoryLs = item.children
            name = item.name
          }
        })
    },
    /** 修改三级级类目 */
    changeThirdCategory(id) {
      this.initSkuInfo()
      this.thirdCategoryLs &&
        this.thirdCategoryLs.forEach(item => {
          if (item.id === id) {
            this.goodsData.categoryId = item.id
            this.goodsData.categoryName = item.name
            this.minPriceRange = item.minPriceRange / 100
            this.maxPriceRange = item.maxPriceRange / 100
          }
        })
      this.getSkuValueLt()
    },
    caizhiHandler(rule, value, callback) {
      const { field } = rule
      if (field === '材质' && this.$refs['材质'] && this.$refs['材质'][0]) {
        let { value: itemName = '' } = this.propertyList.find(item => item.text === '品名')
        if (itemName) {
          if (
            value &&
            this.$refs['材质'][0].$refs['suggestion'].suggestions &&
            this.$refs['材质'][0].$refs['suggestion'].suggestions
              .map(({ value }) => value)
              .indexOf(value) === -1
          ) {
            return callback(new Error('非常规材质'))
          }
        }
      }
      callback()
    },
    /** 选择是否是预售,不是去掉交货期 */
    changeFuturesType(val) {
      console.log(val)
      if (val === '现货') {
        this.showDeliveryDate = false
      } else if (val === '预售') {
        this.showDeliveryDate = true
      }
    },
    /** 获取sku属性列表 */
    async getSkuValueLt(id) {
      try {
        const result = await this.$post(`items.getCategoryPropertyList`, {
          categoryId: this.goodsData.categoryId,
          subItemType: this.indefinite.itemExtInfoVO.subItemType === 'UNCERTAIN' ? 2 : 1
        })
        if (result.success) {
          /** sku 属性列表 */
          let valueLs = result.data && result.data[0].value
          valueLs &&
            valueLs.forEach(item => {
              /** type === 2 非销售属性 存在item中 type === 3 销售属性 存在sku中 */
              let list = item.valueForCategoryVOs || []
              if (item.type === 2) {
                if (item.require && item.propertyForCategoryVO.type === 'ENUM') {
                  item.propertyForCategoryVO.value = list[0].text
                  item.propertyForCategoryVO.list = list
                } else {
                  item.propertyForCategoryVO.list = [{ text: '不选择' }].concat(list)
                  item.propertyForCategoryVO.value = ''
                }
                this.propertyList.push(
                  Object.assign(item.propertyForCategoryVO, { require: item.require })
                )
              } else if (item.type === 3) {
                let obj = {
                  pId: item.propertyForCategoryVO.id,
                  pTxt: item.propertyForCategoryVO.text,
                  type: item.propertyForCategoryVO.type,
                  pType: 'TEXT',
                  require: item.require,
                  vId: '',
                  vTxt: '',
                  list
                }
                // 热卷冷度计量方式默认抄码
                if (this.secendCategoryId === 10241246 || this.secendCategoryId === 10241202) {
                  if (obj.pId === 37) {
                    let chaoma = {}
                    obj.list &&
                      obj.list.forEach(l => {
                        if (l.id === 124) chaoma = l
                      })
                    console.log(chaoma)
                    obj.vId = chaoma.id || ''
                    obj.vTxt = chaoma.text || ''
                  }
                }
                this.skuList[0].itemSkuPVPairList.push(obj)
                this.skuPVPairList.push(obj)
              }
            })
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 删除图片 */
    handleRemove(file, fileList) {
      this.imageList = fileList
    },
    /** 上传图片成功 */
    handleSuccess(response, file, fileList) {
      console.log(fileList)
      this.imageList = fileList
    },
    /** 图片超出上线 */
    beforeUpload(file, fileList) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isLt5M
    },
    handleExceed() {
      this.$message.error('最多上传5张！')
    },
    /** 关闭单前页面 */
    closePage() {
      this.$router.go(-1)
      this.$store.dispatch('tagsView/delView', { path: this.$route.path, name: this.$route.name })
    },
    /** 商品表单数据验证 */
    formVerification() {
      if (!this.categoryId) return this.$message.error('请选择当前类目')
      if (!this.goodsData.warehouseId) return this.$message.error('请选择仓库')
      if (!this.indefinite.itemExtInfoVO.transportTemplateId) {
        const isChecked = this.$refs['freight-set'].getIsChecked()
        if (isChecked) {
          return this.$message.error('请选择运费模版')
        }
      }
      if (this.priceErrors.length > 0) {
        let row = ''
        this.priceErrors.forEach((item, index) => {
          if (item) {
            if (!row) {
              row += `${index + 1} `
            } else {
              row += `, ${index + 1} `
            }
          }
        })
        if (row) {
          return this.$message.error(`第${row}行商品的单件价格超出范围`)
        }
      }
      let errorMeassage = ''
      this.propertyList.forEach(item => {
        if (
          item.text !== '交货期' &&
          (!item.value || item.value === '不选择') &&
          !errorMeassage &&
          item.require
        ) {
          errorMeassage = `请填写${item.text}`
        }
        if (item.text === '交货期' && this.showDeliveryDate && !item.value) {
          errorMeassage = `请选择交货期`
        }
        item.value = item.value === '不选择' ? '' : item.value
      })
      /** 非明确sku销售属性的验证 */
      if (this.indefinite.itemExtInfoVO.subItemType === 'UNCERTAIN') {
        if (!Number(this.indefinite.marketPrice)) return this.$message.error('请输入单价')
        if (!Number(this.indefinite.stockNum)) return this.$message.error('请输入库存总数量')
        if (!Number(this.indefinite.itemExtInfoVO.amountPerUnit))
          return this.$message.error('请输入单件重')
        if (
          Number(this.indefinite.itemExtInfoVO.minOrderAmount) > Number(this.indefinite.stockNum)
        ) {
          return this.$message.error('最小起订量不可以大于库存总数量')
        }
      } else {
        this.skuList.forEach((item, index) => {
          if (!String(item.stockNum) && !errorMeassage)
            errorMeassage = `请填写第${index + 1}行商品的库存`
          if (!(item.price * 100) && !errorMeassage)
            errorMeassage = `请填写第${index + 1}行商品的单件价格`
          if (!(item.amountPerUnit * 1000) && !errorMeassage)
            errorMeassage = `请填写第${index + 1}行商品的单件重`
          item.itemSkuPVPairList.forEach(_item => {
            if (!_item.vTxt && !errorMeassage && _item.require)
              errorMeassage = `请填写第${index + 1}行商品的${_item.pTxt}`
          })
        })
      }
      if (errorMeassage) return this.$message.error(errorMeassage)
      /** 商品图片处理 */
      if (this.imageList.length > 0) {
        this.goodsData.mainPicUrl = ''
        this.imageList.forEach((file, index) => {
          if (index === 0) {
            this.goodsData.mainPicUrl += file.response.data
          } else {
            this.goodsData.mainPicUrl += `|${file.response.data}`
          }
        })
      } else {
        this.goodsData.mainPicUrl = ''
      }
      /** 处理sku数据 */
      return 'success'
    },
    /** 创建商品数据提交 */
    async submit(status, update) {
      if (this.formVerification() === 'success') {
        this.goodsData.status = status
        let skuList = JSON.parse(JSON.stringify(this.skuList))
        skuList.forEach((item, index) => {
          item.stockNum *= 1
          item.price = +parseInt((item.price * 100).toPrecision(12))
          item.costPrice = +parseInt((item.costPrice * 100).toPrecision(12))
          item.amountPerUnit = +parseInt((item.amountPerUnit * 10000).toPrecision(12))
          item.itemSkuPVPairList.forEach(_item => {
            _item.list && delete _item.list
          })
        })
        let obj = JSON.parse(JSON.stringify(this.indefinite))
        obj.marketPrice = +parseInt((obj.marketPrice * 100).toPrecision(12))
        obj.costPrice = +parseInt((obj.costPrice * 100).toPrecision(12))
        obj.itemExtInfoVO.amountPerUnit = +parseInt(
          (obj.itemExtInfoVO.amountPerUnit * 10000).toPrecision(12)
        )
        this.propertyList.forEach(item => {
          item.list && delete item.list
        })
        try {
          const result = await this.$post('items.addItem', {
            itemAddVO: {
              itemVO: Object.assign(this.goodsData, obj, {
                skuList,
                propertyList: this.propertyList
              }),
              update: !!update
            }
          })
          if (result.success) {
            if (result.data[0].again) {
              this.$confirm(
                `你上传的商品和【ID：${result.data[0].itemVO.id} 品材规产】重复，为防止重复铺货，是否覆盖已上架的商品？`,
                '重复商品提醒',
                {
                  distinguishCancelAndClose: true,
                  center: true,
                  confirmButtonText: '确认覆盖',
                  cancelButtonText: '我再考虑一下'
                }
              )
                .then(() => {
                  this.submit(status, true)
                })
                .catch(action => {
                  console.log(action)
                })
            } else if (result.data[0].itemVO) {
              this.addPictureText2Goods(
                result.data[0].itemVO.outerId,
                result.data[0].itemVO.outerType
              )
            }
          } else if (result.data.stat.stateList[0]) {
            /** 商品价格超出范围 */
            if ([4000303, 4000304].indexOf(result.data.stat.stateList[0].code) > -1) {
              try {
                const result = await this.$post('items.getCategoryTree')
                if (result.success) {
                  this.firstCategoryLs = result.data
                  this.firstCategoryLs.forEach(first => {
                    first.children &&
                      first.children.forEach(secend => {
                        secend.children &&
                          secend.children.forEach(third => {
                            if (third.id === result.data[0].categoryId) {
                              this.minPriceRange = third.minPriceRange
                              this.maxPriceRange = third.maxPriceRange
                            }
                          })
                      })
                  })
                  this.skuList.forEach((item, index) => {
                    this.checkSkuPrice(index, true)
                  })
                } else {
                  this.$message.error('获取类目列表失败')
                }
              } catch (err) {
                this.$message.error('获取类目列表失败')
                console.log(err)
              }
            }
          }
        } catch (err) {
          console.log(err)
        }
      }
    },
    /** 添加图文详情 */
    async addPictureText2Goods(outId, outType) {
      try {
        const result = await this.$post('comcenter.addPictureText', {
          poictureTextListQuery: {
            pictureTextItemInfoList: this.goodsDetail.length === 0 ? [{}] : this.goodsDetail,
            outType,
            outId
          }
        })
        if (result.success) {
          this.goodsDetail = []
          this.$store.dispatch('tagsView/delView', {
            path: this.$route.path,
            name: this.$route.name
          })
          this.$router.push({
            path: '/goods/list',
            query: {
              type: 'refresh'
            }
          })
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 修改运费模版
    onChangeTransportTemplate(id) {
      this.indefinite.itemExtInfoVO.transportTemplateId = id
    }
  }
}
</script>

<style lang="stylus" scoped>
.w-185
  width 185px

.sku
  max-width 1000px
  margin 0 auto

  h3
    margin 20px 0 15px

    .tip
      font-size 12px
      margin 6px 0 20px
      color #999

  .ml-20
    margin-left 20px

  .mb-40
    margin-bottom 40px

  /deep/.el-form-item__label
    text-align left

  .operate
    text-align center
    margin-top 40px

  .upload-tips
    color #999
    font-size 12px

  /deep/.el-table td
    padding 5px 0

  /deep/.w-300
    width 300px

  /deep/.el-table .el-input__inner
    height 30px
    line-height 30px
    padding 0 8px

  .opacity
    /deep/.el-upload
      display none

/deep/.el-select .el-input .el-select__caret
  line-height 30px

.operate-btn
  position fixed
  bottom 40px
  height 80px
  width calc(100% - 230px)
  background-color #fff
  box-shadow 0 0 5px #ccc
  padding 10px 0
  .flex
    display flex
    align-items center
    justify-content center
  .tips
    text-align center
    font-size 12px
    color #999
    margin-top 10px
/deep/.bor-red
  input
    border-color red
</style>
